import moment from 'moment'

/** @var value format unix time */
export const unixTimeToCzDate = (value?: number) =>
  value ? moment(value).format('DD.MM.YYYY') : ''

export const unixTimeToISODate = (value?: number | null) =>
  value ? moment(value).format('YYYY-MM-DD') : ''

export const czDateToUnixTime = (value: any) =>
  isCzechDate(value) ? moment.utc(value, 'D.M.Y').valueOf() : ''

export const isCzechDate = (value: string) => moment(value, 'D.M.Y', true).isValid()

export const isCzechDateAfter = (value: string) =>
  moment().isAfter(moment(czDateToUnixTime(value)), 'day')

export const isCzechDateBefore = (value: string) =>
  moment().isBefore(moment(czDateToUnixTime(value)), 'day')

export const isoToCzDate = (value: string) => moment(value).format('DD.MM.YYYY')

export const isoToCzTime = (value: string) => moment(value).format('h:mm')
